export enum TariffTypeEnum {
  EYE_OF_GOD = 'eye_of_god',
  CYBERSEC = 'cybersec',
  BROGO = 'brogo',
  FREE = 'free',
  DEPOSIT = 'deposit',
  MANUAL = 'deposit_manually',
}

export interface ICreateTariff {
  name: string
  type: TariffTypeEnum
  price: number
}

export interface ITariff extends ICreateTariff {
  id: string
}
